module.exports = __webpack_public_path__ + "img/contract.0eef33f6.png";